import { Charts } from './Charts';
import PreviousPregnanciesChartsDataProvider from './contexts/PreviousPregnanciesChartsDataContext';

const PreviousPregnanciesWrapper = () => {
    return (
        <PreviousPregnanciesChartsDataProvider>
            <Charts />
        </PreviousPregnanciesChartsDataProvider>
    );
};

export default PreviousPregnanciesWrapper;
